/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-06-26 09:20:22
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbInventory {
    /**
     * 库存盘点单列表
     */
    export var GetTbInventoryList = (body: any): Promise<any> => {
        return Get(`/api/TbInventory/GetTbInventoryList`, body);
    };
    /**
     * 获取盘点单明细
     */
    export var GetTbInventoryById = (body: any): Promise<any> => {
        return Get(`/api/TbInventory/GetTbInventoryById`, body);
    };
    
    
   
  
    
}



// WEBPACK FOOTER //
// ./src/http/api_TbInventory.ts